import { Button, Paper, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconArrowRight, IconChecks, IconClockHour4, IconMessages, IconStarFilled } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { formatReviewCount, getReviewSummary } from "../../Services/review.service";
import "./Reviews.css";

interface ReviewsTrustBarProps {
  showLink?: boolean;
  compact?: boolean;
  unstyled?: boolean;
}

function ReviewsTrustBar({
  showLink = true,
  compact = false,
  unstyled = false,
}: ReviewsTrustBarProps) {
  const theme = useMantineTheme();
  const summary = getReviewSummary();
  const iconSize = compact ? 18 : 20;

  const trustItems = [
    {
      icon: <IconStarFilled size={iconSize} />,
      value: `${summary.averageRating.toFixed(1)}/5`,
      label: `${formatReviewCount(summary.totalReviews)} verified reviews`,
    },
    {
      icon: <IconChecks size={iconSize} />,
      value: `${summary.onTimeRate}%`,
      label: "deadline support mentions",
    },
    {
      icon: <IconMessages size={iconSize} />,
      value: `${summary.clarityRate}%`,
      label: "clearer explanation mentions",
    },
    {
      icon: <IconClockHour4 size={iconSize} />,
      value: `${summary.supportResponseMinutes} min`,
      label: "typical response window",
    },
  ];

  return (
    <Paper
      withBorder={!unstyled}
      radius="xl"
      p={compact ? "md" : "lg"}
      className={`subjectbuddy-review-trust-bar${unstyled ? " subjectbuddy-review-trust-bar--plain" : ""}`}
    >
      <div className="subjectbuddy-review-trust-layout">
        <div className="subjectbuddy-review-trust-items">
          {trustItems.map((item) => (
            <div key={item.label} className="subjectbuddy-review-trust-item">
              <div
                className="subjectbuddy-review-icon-badge"
                style={{
                  background: theme.colors.green[0],
                  color: theme.colors.green[7],
                }}
              >
                {item.icon}
              </div>
              <Stack gap={0} className="subjectbuddy-review-trust-copy">
                <Text fw={800}>{item.value}</Text>
                <Text size="sm" c="dimmed">
                  {item.label}
                </Text>
              </Stack>
            </div>
          ))}
        </div>

        {showLink ? (
          <Button
            component={Link}
            to="/reviews"
            variant="light"
            color="green"
            radius="xl"
            rightSection={<IconArrowRight size={16} />}
            className="subjectbuddy-review-trust-cta"
          >
            Read reviews
          </Button>
        ) : null}
      </div>
    </Paper>
  );
}

export default ReviewsTrustBar;
